import React from 'react';
import { motion } from 'framer-motion';

function Services() {
  const services = [
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/ai-agents.jpg',
      title: 'AI Agents',
      description: 'A smart assistant that talks to your customers just like a real person — answering questions, booking appointments, and following up. It works 24/7 so you never miss a call, even on weekends and holidays.'
    },
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/workflow.jpg',
      title: 'Workflow Automation',
      description: 'Stop doing the same tasks over and over. We automate your follow-ups, reminders, and paperwork so nothing falls through the cracks — saving you 15+ hours a week.'
    },
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/crm.jpg',
      title: 'CRM Integration',
      description: 'All your customer info in one place — no more sticky notes or spreadsheets. We connect your phone, email, and booking system so every lead is tracked automatically.'
    },
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/text.jpg',
      title: 'Smart Communication',
      description: 'Text, email, and message your customers from one place. Automatic replies mean your customers hear back in minutes, not hours — even when you are busy.'
    },
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/analytics.jpg',
      title: 'Analytics & Insights',
      description: 'See exactly how your business is doing — how many calls came in, how many turned into customers, and where you are losing money. Simple reports, no tech degree required.'
    },
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/phone-sys.jpg',
      title: 'AI Phone Systems',
      description: 'Your phone gets answered in under 2 seconds, every time. No more missed calls, no more voicemail. Our clients save an average of $17,000 a year on phone staffing alone.'
    },
    {
      image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/ai-agents.jpg',
      title: 'Mobile Apps (iOS & Android)',
      description: 'Your own branded iOS and Android app — customers book, message, and get push notifications when their order, appointment, or follow-up is ready. We design, build, and ship to the App Store and Google Play, and connect it to your AI agent so every tap is handled instantly.'
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="studio-section-heading">
          <div>
            <span className="studio-eyebrow">Built around your business</span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              Less busywork.<br />More possibility.
            </motion.h2>
          </div>
          <p>From the first call to the follow-up, we connect the pieces so your business runs beautifully.</p>
        </div>
        <div className="services-grid">
          {services.map(({ title, description, image }, index) => (
            <motion.div
              key={title}
              className="service-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="service-icon"><img src={image} alt={title} loading="lazy" decoding="async" width="640" height="400" /></div>
              <h3>{title}</h3>
              <p>{description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
